'use client'
import React, { FC } from 'react'

import classNames from 'classnames'
import styles from './CollectionCardSmall.module.css'
import CollectionIcon from '@/components/collection-icon'

const CollectionCardSmall: FC<{
	rank?: number
	className?: string
	collection: any
}> = (props) => {
	const { className, collection, rank: _rank } = props

	return (
		<div className={classNames({ [(props.className as any)]: !!className }, styles.root)}>
			<div className={classNames('columns-2', styles.rankAndIconContainer)}>
				<div className={styles.rankText}>{collection?.num}</div>
				<CollectionIcon
					className={styles.icon}
					imageClassName={styles.icon}
					collection={collection}
				/>
			</div>
			<div className={styles.body}>
        <h3 className={styles.title}>{collection?.name}</h3> 
				<div className={styles.subtitle}>
					<p className={classNames(styles.description, 'text-sm')}>{collection?.id} </p>
				</div>
			</div>
		</div>
	)
}

export default CollectionCardSmall
